import React from 'react';
import { salonInfo } from '../data/mock';
import { useLanguage } from '../i18n/LanguageContext';

export const Philosophy = () => {
  const { t } = useLanguage();
  const openWhatsApp = () => {
    window.open(`https://wa.me/${salonInfo.whatsapp.replace(/\s|\+/g, '')}`, '_blank');
  };

  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="py-24 md:py-32 bg-neutral-950 text-neutral-100"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl mb-24 md:mb-32">
          <div className="flex items-center gap-4 mb-10">
            <span className="divider-line"></span>
            <span className="eyebrow text-lilac">{t.philosophy.eyebrow}</span>
          </div>
          <p className="eyebrow text-sage mb-5">{t.philosophy.unnieLabel}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] text-neutral-100 tracking-tight mb-10">
            {t.philosophy.unnieTitleA}
            <span className="block italic text-lilac font-light mt-2">
              {t.philosophy.unnieTitleB}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-neutral-400 leading-relaxed font-light max-w-2xl">
            {t.philosophy.unnieIntro}
          </p>
        </div>

        <div className="space-y-16 md:space-y-24 max-w-4xl mx-auto">
          {t.philosophy.blocks.map((b, i) => {
            const n = String(i + 1).padStart(2, '0');
            return (
              <div
                key={i}
                data-testid={`philosophy-block-${n}`}
                className="grid grid-cols-12 gap-6 md:gap-10 border-t border-white/10 pt-10 md:pt-14"
              >
                <div className="col-span-12 md:col-span-3">
                  <p className="font-display text-sm text-lilac tabular-nums mb-2">{n}</p>
                  <p className="eyebrow text-sage">{b.eyebrow}</p>
                </div>
                <div className="col-span-12 md:col-span-9">
                  <h3 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-neutral-100 mb-6 tracking-tight">
                    {b.title}
                  </h3>
                  <div className="text-lg md:text-xl text-neutral-400 leading-relaxed font-light max-w-2xl space-y-4">
                    {b.body.split('\n\n').map((para, j) => (
                      <p key={j}>{para}</p>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-24 md:mt-32 max-w-4xl mx-auto border-t border-white/10 pt-14">
          <p className="font-display italic text-2xl md:text-3xl text-neutral-300 font-light mb-4 max-w-2xl">
            {t.philosophy.closingTitle}
            <span className="text-lilac">{t.philosophy.closingTitleAccent}</span>
          </p>
          <p className="text-base text-neutral-500 leading-relaxed font-light max-w-2xl mb-10">
            {t.philosophy.closingBody}
          </p>
          <button
            onClick={openWhatsApp}
            data-testid="philosophy-cta-whatsapp"
            className="group inline-flex items-center gap-4 eyebrow text-neutral-100 border-b border-lilac pb-2 hover:text-lilac transition-colors"
          >
            {t.cta.whatsapp}
            <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};
